import useGTMUtil, { GTMPageData } from '../../../lib/useGTMUtil';

export default () => {
  const { postGTMData } = useGTMUtil();

  const CDI = 'contact data intercept';
  const pageDataCDI: GTMPageData = {
    pageName: CDI,
    siteSection: 'contact data intercept modal',
    siteSubSection: CDI,
    journeyName: CDI,
    subJourneyName: CDI,
    pageTime: new Date().toISOString(),
  };

  const gtm_CDI_HandleShowModal = () => {
    postGTMData({
      pageData: pageDataCDI,
      actionData: {
        actionLocation: 'modal',
        actionType: 'show',
        actionLabel: 'show contact data intercept modal',
        actionTime: new Date().toISOString(),
        actionElement: 'login',
        actionSubType: '',
        actionOutcome: '',
      },
    });
  };

  const gtm_CDI_HandleDismissModal = () => {
    postGTMData({
      pageData: pageDataCDI,
      actionData: {
        actionLocation: 'modal',
        actionType: 'click',
        actionLabel: 'dismiss contact data intercept modal',
        actionTime: new Date().toISOString(),
        actionElement: 'button',
        actionSubType: 'click',
        actionOutcome: 'close',
      },
    });
  };

  const gtm_CDI_HandleInformationIsCorrect = () => {
    postGTMData({
      pageData: pageDataCDI,
      actionData: {
        actionLocation: 'modal',
        actionType: 'click',
        actionLabel: 'information is correct',
        actionTime: new Date().toISOString(),
        actionElement: 'button',
        actionSubType: 'click',
        actionOutcome: 'close',
      },
    });
  };

  const gtm_CDI_HandleUpdateInformation = () => {
    postGTMData({
      pageData: pageDataCDI,
      actionData: {
        actionLocation: 'modal',
        actionType: 'click',
        actionLabel: 'update information',
        actionTime: new Date().toISOString(),
        actionElement: 'button',
        actionSubType: 'click',
        actionOutcome: 'close',
      },
    });
  };

  return {
    gtm_CDI_HandleShowModal,
    gtm_CDI_HandleDismissModal,
    gtm_CDI_HandleInformationIsCorrect,
    gtm_CDI_HandleUpdateInformation,
  };
};
